import MidSec from "./MidSec";
import { Parallax } from "react-parallax";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import Feeds from "./Feeds";
import wbc from "../wbc.png";
import xtremex from "../xtreme-in.png";
import logo from "../logo.png";
import beco from "../becomemem.jpeg";
import { ButtonLeft } from "./Button";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import LoadingPost from "./LoadingPost";
import banner from "./pages/wbc _landing_2026/banner1.jpeg";


function Home() {
  const [newsData, setNewsData] = useState(null)
  const [eventData, setEventData] = useState(null)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_MINF_BAC_BASE}/featured`);
        const response2 = await axios.get(`${process.env.REACT_APP_MINF_BAC_BASE}/events`);
        if (response) {
          const reverse = response.data.reverse();
          const reverse2 = response2.data.reverse();
          setNewsData(reverse);
          setEventData(reverse2);
        }
      } catch (error) {
        console.log(`Error fetching data: ${error.message}`);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="">
      <div className={`absolute w-full top-4 md:top-8 left-0 h-[70vh] px-5 md:h-[92vh]`}>
        <video
          className="h-full w-full bg-gray-700 rounded-2xl object-cover"
          muted
          autoPlay
          loop
        >
          <source
            src="https://cdn.wbcamateurmuaythaiindia.com/minf-uploads/videos/aug_vid2.mp4"
            type="video/mp4"
          />
        </video>
      </div>
      <div className="h-[70vh] md:h-[100vh]">

      </div>
      <div className={` mx-auto pb-5`}>

        <div className="thermite flex mt-5 h-[80px] w-full items-center justify-center text-4xl md:text-5xl">
          TRENDING NOW
        </div>
        <div className="container mx-auto px-5">
          <div>
            <div className="mb-5 flex justify-between border-b-2 border-gray-400">
              <p className="protest pb-2 text-3xl text-gray-700">Featured</p>
              <p className="thermite hidden cursor-pointer text-lg text-gray-500 md:block">
                <a href="/news">view all</a>{" "}
                <KeyboardArrowRightRoundedIcon />
              </p>
            </div>
            <div className=" w-full my-12 container w-[90%] mx-auto rounded-xl">
              <div className=" w-full container mx-auto grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-5 ">
                {newsData ? (newsData.slice(0, 4).map((d, i) => (
                  <MidSec data={d} getTo="featureupdate" key={i} />
                ))) : <LoadingPost />}
              </div>
            </div>
          </div>

          <div className="">
            <div className="mb-5 flex justify-between border-b-2 border-gray-400"></div>
            <Feeds />
          </div>
          <div>
            <div className="mt-5 flex justify-between border-b-2 border-gray-400">
              <p className="protest pb-2 text-3xl text-gray-700">Events</p>
              <p className="thermite hidden cursor-pointer text-lg text-gray-500 md:block">
                <a href="/events">view all</a> <KeyboardArrowRightRoundedIcon />
              </p>
            </div>
            <div className=" w-full my-12 container w-[90%] mx-auto rounded-xl">
              <div className=" w-full container mx-auto grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-5 ">
                {eventData ? (eventData.slice(0, 4).map((d, i) => (
                  <MidSec data={d} getTo="events" key={i} />
                ))) : <LoadingPost />}
              </div>
            </div>
            <div className="thermite text-md mx-auto mb-12 mt-5 block h-[50px] w-[70%] md:hidden">
              <a href="/events">
                <ButtonLeft prop={"load more"} />
              </a>
            </div>
          </div>
        </div>

        <Parallax
          blur={3}
          bgImage="https://i.pinimg.com/originals/ca/7d/2f/ca7d2fd4c3ed6ebac88e5ff2a90810ce.jpg"
          bgImageAlt="the collab"
          strength={50}
        >
          <div className=" flex h-[300px] w-full flex-col items-center justify-center md:h-[500px]">
            <p className="thermite text-center text-2xl text-white opacity-80 md:text-4xl">
              Collaboration
            </p>
            <div className="flex h-[150px] w-full items-center justify-center gap-5 md:h-[250px] md:gap-28">
              <img
                src={xtremex}
                alt=""
                className=" h-[60px] object-cover md:h-[150px]"
              />
              <img
                src={logo}
                alt=""
                className=" h-[60px] object-cover md:h-[150px]"
              />
              <img
                src={wbc}
                alt=""
                className=" h-[60px] object-cover md:h-[150px]"
              />
            </div>
          </div>
        </Parallax>
      </div>

      <div className="my-12">
        <Parallax blur={3} bgImage={beco} bgImageAlt="the mem" strength={50}>
          <div className="flex h-[60vh] w-full items-center justify-center">
            <div className="glass flex h-[70%] w-[70%] flex-col items-center justify-center gap-12">
              <p className=" protest text-center text-3xl text-white md:text-6xl">
                BECOME A MEMBER
              </p>
              <a href="/jnwbcamti"><button className="protest transition-bg border-4 border-white bg-transparent px-8 py-3 text-2xl text-white duration-200 hover:bg-red-600 md:text-4xl">
                Apply <KeyboardArrowRightRoundedIcon />
              </button></a>
            </div>
          </div>
        </Parallax>
      </div>
    </div>
  );
}

export default Home;
